import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export class ChatMessage {
    targetUserId: number;
    threadId: number;
    auctionId: number;
    productId: number;
    message: string;
    author: string;
    pending = false;
    added: string;

    public constructor(thread?: Partial<ChatMessage>) {
        Object.assign(this, thread);

        if (this.added != null) {
            if (!this.added.endsWith('Z')) {
                this.added = this.added + 'Z';
            }
            this.added = DateTimeHelper.formatDate(this.added);
        }
    }
}
